export class DoubleRange {
    /**
     * Class constructor
     * @param {HTMLElement} element - inputs wrapper element
     * @returns this
     */
    constructor(element) {
        this.element = element;
        this.fromSlider = element.querySelector('[data-component~="double-range-from-slider"]');
        this.fromInput = element.querySelector('[data-component~="double-range-from-input"]');
        this.toSlider = element.querySelector('[data-component~="double-range-to-slider"]');
        this.toInput = element.querySelector('[data-component~="double-range-to-input"]');

        return this.init();
    }

    /**
     * Init class
     * @returns this
     */
    init() {
        return this.initEventListeners().setVariables();
    }

    /**
     * Attach all required event listeners
     * @returns this
     */
    initEventListeners() {
        this.fromSlider.addEventListener('input', () => {
            const [from, to] = this.getValue(this.fromSlider, this.toSlider);

            if (from > to) {
                this.fromSlider.value = to;
                this.fromInput.value = to;
            } else {
                this.fromInput.value = from;
            }

            this.setVariables();
        });

        this.fromInput.addEventListener('input', () => {
            const [from, to] = this.getValue(this.fromInput, this.toInput);

            if (from > to) {
                this.fromSlider.value = to;
                this.fromInput.value = to;
            } else {
                this.fromSlider.value = from;
            }

            this.setVariables();
        });

        this.toSlider.addEventListener('input', () => {
            const [from, to] = this.getValue(this.fromSlider, this.toSlider);

            this.toInput.value = from <= to ? to : from;
            this.toSlider.value = from <= to ? to : from;

            this.setVariables();
        });

        this.toInput.addEventListener('input', () => {
            const [from, to] = this.getValue(this.fromInput, this.toInput);

            if (from <= to) {
                this.toSlider.value = to;
                this.toInput.value = to;
            } else {
                this.toInput.value = from;
            }

            this.setVariables();
        });

        return this;
    }

    /**
     * Get two input numeric values
     * @param {HTMLInputElement} fromInput - least value input
     * @param {HTMLInputElement} toInput - greatest value input
     * @returns [Number, Number]
     */
    getValue(fromInput, toInput) {
        return [Number(fromInput.value), Number(toInput.value)];
    }

    /**
     * Set CSS variables and other attributes according to the current values
     * @returns this
     */
    setVariables() {
        const rangeDistance = this.fromInput.max - this.fromInput.min;
        let fromPosition = (this.fromInput.value - this.fromInput.min) / rangeDistance * 100;
        let toPosition = (this.toInput.value - this.toInput.min) / rangeDistance * 100;

        if (fromPosition < 0) {
            fromPosition = 0;
        }
        if (toPosition > 100) {
            toPosition = 100;
        }
        this.element.style.setProperty('--from-position', `${fromPosition}%`);
        this.element.style.setProperty('--to-position', `${toPosition}%`);
        this.element.setAttribute('data-from-value', this.fromInput.value);
        this.element.setAttribute('data-to-value', this.toInput.value);

        return this;
    }
}

document.addEventListener( 'DOMContentLoaded', function() {
    for (let element of document.querySelectorAll('[data-component~="double-range"]')) {
        element.doubleRange = new DoubleRange(element);
    }
});
